import React from 'react';

type LayersIconProps = React.SVGProps<SVGSVGElement>;

const LayersIcon: React.FC<LayersIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 1.5L12.75 3L18.75 3L18.75 14.25L20.25 14.25L20.25 3C20.2495 2.60232 20.0914 2.22105 19.8102 1.93984C19.5289 1.65864 19.1477 1.50046 18.75 1.5L12.75 1.5ZM9 5.25L9 6.75L15 6.75L15 18L16.5 18L16.5 6.75C16.4995 6.35232 16.3414 5.97105 16.0602 5.68984C15.7789 5.40864 15.3977 5.25046 15 5.25L9 5.25ZM3.75 21L3.75 10.5C3.75046 10.1023 3.90864 9.72105 4.18984 9.43984C4.47105 9.15864 4.85231 9.00046 5.25 9L11.25 9C11.6477 9.00046 12.0289 9.15864 12.3102 9.43984C12.5914 9.72105 12.7495 10.1023 12.75 10.5L12.75 21C12.7495 21.3977 12.5914 21.779 12.3102 22.0602C12.0289 22.3414 11.6477 22.4995 11.25 22.5L5.25 22.5C4.85231 22.4995 4.47105 22.3414 4.18984 22.0602C3.90864 21.779 3.75046 21.3977 3.75 21ZM5.25 21L11.25 21L11.25 10.5L5.25 10.4991L5.25 21Z"
        fill={fill}
      />
    </svg>
  );
};

export default LayersIcon;
